// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3kAVA","content":"RecentSearches_content__2oOGM"};